<template>
  <div class="nd-address">
    <van-popup
      v-model="visible"
      position="bottom"
    >
      <div class="nd-address-popup">
        <div class="nd-address-header">
          <div class="nd-address-toolbar">
            <span>{{ provinceCode ? '请选择' : '地区选择' }}</span>
            <img src="../nd-choose/images/close.png" @click="visible = false">
          </div>
        </div>
                
        <div class="nd-address-content">
          <div class="nd-address-select-list" v-show="provinceCode">
            <div class="province-select select-item" :class="{ 'active': activeNode === 0 }" @click="activeNode = 0">
              {{ provinceName }}
            </div>
            <div class="city-select select-item" :class="{ 'active': activeNode === 1, 'hasvalue': cityCode }" @click="activeNode = 1" v-if="columns >= 2 && provinceCode">
              {{ cityName || '请选择城市' }}
            </div>
            <div class="city-select select-item" :class="{ 'active': activeNode === 2, 'hasvalue': areaCode }" @click="activeNode = 2" v-if="columns === 3 && cityCode">
              {{ areaName || '请选择区/县' }}
            </div>
          </div>

          <div ref="ndAddressList" class="nd-address-list">
            <div class="hotcity-wrapper" v-show="!provinceCode">
              <div class="nd-address-content-title">
                热门城市
              </div>
              <div class="hotcity-list clearfix">
                <div class="hotcity-item"
                     v-for="(item, index) in hotcityList"
                     :key="index"
                     @click="hotcityHandler(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="nd-address-content-title gutter">
              {{ activeNodeText }}
            </div>
            <div class="nd-address-item"
                 v-for="(item, index) in expandList"
                 :key="index"
                 @click="selectHandler(item)"
            >
              <span class="idx">
                <template v-if="(index - 1 >= 0 && item.idx !== expandList[index -1].idx) || index === 0">
                  {{ item.idx }}
                </template>
              </span>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="nd-inner-input" @click="visible = true">
      <input
        type="text"
        class="nd-select-text"
        :class="textAlign"
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="!editable"
        :value="bindText"
        :style="inputStyle"
        :name="name"
        ref="input"
      >
      <label :for="name" v-if="label">{{ label }}</label>
      <i class="arrow-icon"></i>
      <input 
        type="hidden"
        :value="currentValue"
      >
    </div>
  </div>
</template>
<script>
import { Popup } from 'vant'
// 处理地址json数据，符合组件数据规范
import province from './data/province'
import city from './data/city'
import area from './data/area'

export default {
  name: 'nd-address',

  components: {
    'van-popup': Popup
  },

  props: {
    name: String,
    placeholder: {
      type: String,
      default: '请选择'
    },
    label: String,
    value: {
      type: String | Number,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    },
    inputStyle: String,
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    readonly: {
      type: Boolean,
      default: true
    },
    title: String,
    textAlign: {
      type: String,
      default: 'right'
    },
    // 选择地址的层级，3级表示省市区、2级表示省市、1级表示省
    columns: {
      type: Number,
      default: 3
    }
  },

  data () {
    return {
      bindValue: this.value,
      currentValue: this.value,
      provinceList: province,
      cityList: city,
      areaList: area,
      visible: false,
      bindText: '',
      provinceCode: '',
      cityCode: '',
      areaCode: '',
      provinceName: '',
      cityName: '',
      areaName: '',
      activeNode: 0, // 激活的节点
      hotcityList: [
        { name: '北京', provinceCode: '110000', cityCode: '110100', provinceName: '北京市', cityName: '北京市' },
        { name: '上海', provinceCode: '310000', cityCode: '310100', provinceName: '上海市', cityName: '上海市' },
        { name: '广州', provinceCode: '440000', cityCode: '440100', provinceName: '广东省', cityName: '广州市' },
        { name: '深圳', provinceCode: '440000', cityCode: '440300', provinceName: '广东省', cityName: '深圳市' },
        { name: '杭州', provinceCode: '330000', cityCode: '330100', provinceName: '浙江省', cityName: '杭州市' },
        { name: '南京', provinceCode: '320000', cityCode: '320100', provinceName: '江苏省', cityName: '南京市' },
        { name: '苏州', provinceCode: '320000', cityCode: '320500', provinceName: '江苏省', cityName: '苏州市' },
        { name: '天津', provinceCode: '120000', cityCode: '120100', provinceName: '天津市', cityName: '天津市' },
        { name: '武汉', provinceCode: '420000', cityCode: '420100', provinceName: '湖北省', cityName: '武汉市' },
        { name: '长沙', provinceCode: '430000', cityCode: '430100', provinceName: '湖南省', cityName: '长沙市' },
        { name: '重庆', provinceCode: '500000', cityCode: '500100', provinceName: '重庆市', cityName: '重庆市' },
        { name: '成都', provinceCode: '510000', cityCode: '510100', provinceName: '四川省', cityName: '成都市' }
      ]
    }
  },

  computed: {
    // 展示的列表
    expandList () {
      switch (this.activeNode) {
        case 0:
          return this.provinceList
        case 1:
          return this.cityList[this.provinceCode]
        case 2:
          return this.areaList[this.cityCode]
      }
    },

    // 当前选择节点
    activeNodeText () {
      switch (this.activeNode) {
        case 0:
          return '选择省份 / 地区'
        case 1:
          return '选择城市'
        case 2:
          return '请选择区/县'
      }
    }
  },

  watch: {
    value (val) {
      this.setCurrentValue(val)
    },

    visible (val) {
      if (val) {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    }
  },

  created () {
    if (this.value) {
      this.setText()
    }
  },

  methods: {
    // 点击地址列表的回调
    selectHandler (item) {
      if (this.activeNode === 0) {
        this.provinceCode = item.id
        this.provinceName = item.name
        if (this.cityCode) {
          this.cityCode = ''
          this.cityName = ''
          this.areaCode = ''
          this.areaName = ''
          this.activeNode = 1
        } else {
          this.cityCode = ''
          this.cityName = ''
          this.areaCode = ''
          this.areaName = ''
          this.activeNode = 1
        }
        this.$refs.ndAddressList.scrollTop = 0
        // 当只有省时，直接显示省
        if (this.columns === 1) {
          return this.completeHandler()
        } else {
          return
        }
      }
      if (this.activeNode === 1) {
        this.cityCode = item.id
        this.cityName = item.name
        this.areaCode = ''
        this.areaName = ''
        this.activeNode = 2
        this.$refs.ndAddressList.scrollTop = 0
        // 当只有省市时，直接显示省市
        if (this.columns === 2) {
          return this.completeHandler()
        } else {
          return
        }
      }
      this.areaCode = item.id
      this.areaName = item.name
      this.completeHandler()
    },

    // 完成选择回调
    completeHandler () {
      let bindText = ''
      let codeValue = ''
      if (this.columns === 3) {
        bindText = `${this.provinceName} ${this.cityName} ${this.areaName}`
        codeValue = `${this.provinceCode} ${this.cityCode} ${this.areaCode}`
      } else if (this.columns === 2) {
        bindText = `${this.provinceName} ${this.cityName}`
        codeValue = `${this.provinceCode} ${this.cityCode}`
      } else if (this.columns === 1) {
        bindText = `${this.provinceName}`
        codeValue = `${this.provinceCode}`
      }
      this.setCurrentValue(bindText + ' ' + codeValue)
      this.$emit('change', bindText, this.name)
      this.visible = false
    },

    // 选择热门城市
    hotcityHandler (hot) {
      this.provinceCode = hot.provinceCode
      this.provinceName = hot.provinceName
      if (this.columns === 1) {
        this.completeHandler()
      } else if (this.columns === 2) {
        this.cityCode = hot.cityCode
        this.cityName = hot.cityName
        this.activeNode = 1
        this.completeHandler()
      } else if (this.columns === 3) {
        this.cityCode = hot.cityCode
        this.cityName = hot.cityName
        this.activeNode = 2
      }
    },

    setCurrentValue (value) {
      this.$emit('input', value)
      this.$refs['input'].dispatchEvent(new Event('input'))
      this.$refs['input'].dispatchEvent(new Event('change'))
      this.currentValue = value
      this.setText()
    },

    setText () {
      if (this.value && this.value.split(' ')) {
        let valueArr = this.value.split(' ')
        this.provinceName = valueArr[0]
        this.cityName = valueArr[1]
        this.areaName = valueArr[2]

        if (this.columns === 3) {
          this.provinceCode = String(valueArr[3])
          this.cityCode = String(valueArr[4])
          this.areaCode = String(valueArr[5])
          this.activeNode = 2
        } else if (this.columns === 2) {
          this.provinceCode = String(valueArr[2])
          this.cityCode = String(valueArr[3])
          this.activeNode = 1
        } else if (this.columns === 1) {
          this.provinceCode = String(valueArr[1])
          this.activeNode = 0
        }

        this.bindText = valueArr.slice(0, this.columns).join(' ')
      }
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

    .nd-address {
        position: relative;
        height: 100%;
        width: 100%;

        .nd-inner-input {
            height: 100%;
            width: 100%;
        }

        input {
            border: none;
            outline: none;
            width: 100%;
            height: 100%;
            color: @fc1;
            font-size: 28px;
            background: transparent;
            font-family: 'PingFangSC-Regular';
            font-weight: 400;
            pointer-events: none;
            display: block;
            &.nd-select-text {
                padding-right: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                &.right {
                    text-align: right;
                }
                &.center {
                    text-align: center;
                }
            }
            &::-moz-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &:-moz-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &::-webkit-input-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &:-ms-input-placeholder { color:@fc4; -webkit-text-fill-color: @fc4;}
            &[disabled], &:disabled, &.disabled {
                background-color: transparent;
                color: @fc1!important;
                -webkit-text-fill-color: @fc1;
                -webkit-opacity: 1;
                opacity: 1;
            }
        }

        label {
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            font-size: 30px;
            background-color: #fff;
            font-family: 'PingFangSC-Regular';
            font-weight: 400;
        }

        .arrow-icon {
            position: absolute;
            top: 50%;
            right: 0;
            height: 20px;
            margin-top: -10px;
            width: 11px;
            background-image: url(../nd-cell/images/arrow.png);
            background-size: 100% 100%;
            display: block;
        }

        .van-popup {
            border-radius: 30px 30px 0px 0px;
            overflow: hidden;

            .nd-address-popup {
                .nd-address-header {
                    .nd-address-toolbar {
                        height: 170px;
                        box-sizing: border-box;
                        padding: 65px 50px 55px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;

                        span {
                            font-size: 36px;
                            font-family: PingFangSC-Medium,PingFang SC;
                            font-weight: 500;
                            color: @fc1;
                        }

                        img {
                            width: 33px;
                            height: 33px;
                        }
                    }
                }

                .nd-address-content {
                    height: 900px;
                    position: relative;
                    display: flex;
                    flex-direction: column;

                    .nd-address-content-title {
                        height: 40px;
                        font-size: 28px;
                        font-family: PingFangSC-Regular,PingFang SC;
                        font-weight: 400;
                        color: @fc4;
                        line-height: 40px;
                        padding-left: 50px;

                        &.gutter {
                            margin-top: 48px;
                        }
                    }

                    .nd-address-select-list {
                        padding-bottom: 38px;
                        position: sticky;
                        width: 100%;
                        border-bottom: 1px solid #EEEEEE;
                        
                        .select-item {
                            height: 40px;
                            line-height: 40px;
                            padding-left: 100px;
                            font-size: 28px;
                            color: @fc1;
                            font-family: PingFangSC-Regular,PingFang SC;
                            font-weight: 400;
                            position: relative;

                            &.active {
                                color: @theme;
                            }

                            &::before {
                                content: '';
                                display: block;
                                position: absolute;
                                border-radius: 6px;
                                top: 14px;
                                left: 51px;
                                width: 12px;
                                height: 12px;
                                background-color: @theme;
                            }

                            &:last-child {
                                &::before {
                                    background-color: #FFFFFF;
                                    border: 2px solid @theme;
                                    box-sizing: border-box;
                                }
                            }

                            &.hasvalue {
                                &::before {
                                    background-color: @theme;
                                    border: 2px solid @theme;
                                    box-sizing: border-box;
                                }
                            }

                            & + .select-item {
                                margin-top: 40px;

                                &::after {
                                    content: '';
                                    display: block;
                                    position: absolute;
                                    width: 2px;
                                    height: 70px;
                                    left: 56px;
                                    top: -56px;
                                    background-color: @theme;
                                }
                            }
                        }
                    }

                    .nd-address-list {
                        overflow: auto;

                        .hotcity-list {
                            margin: 0 50px;
                            line-height: unset;

                            .hotcity-item {
                                float: left;
                                width: 110px;
                                height: 52px;
                                line-height: 52px;
                                text-align: center;
                                font-size: 28px;
                                font-family: PingFangSC-Regular,PingFang SC;
                                font-weight: 400;
                                background-color: #FAFAFA;
                                border-radius: 29px;
                                color: @fc2;
                                margin-top: 48px;
                                margin-left: 25px;

                                &:nth-child(5n + 1) {
                                    margin-left: 0px;
                                }
                            }
                        }

                        .nd-address-item {
                            height: 110px;
                            line-height: 110px;
                            font-size: 30px;
                            font-family: PingFangSC-Regular,PingFang SC;
                            font-weight: 400;
                            color: @fc2;
                            padding: 0 50px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            box-sizing: border-box;

                            .idx {
                                width: 50px;
                                display: inline-block;
                                color: @fc3
                            }
                        }
                    }
                }
            }
        }
    }
</style>
